import React from 'react';
import { Bar } from './SkeletonBar';

// Mirrors WalletPage: greeting header, card carousel, quick-action rail,
// then the transactions list.
const WalletScreenSkeleton = () => (
  <div className="min-h-screen bg-canvas pb-28">
    <div className="max-w-md mx-auto px-5">
      <div className="pt-5 flex items-center justify-between">
        <div className="flex items-center gap-2.5">
          <Bar className="w-10 h-10 shrink-0 rounded-full" />
          <div>
            <Bar className="h-2.5 w-16" />
            <Bar className="mt-1.5 h-3.5 w-24" />
          </div>
        </div>
        <Bar className="w-9 h-9 shrink-0 rounded-full" />
      </div>

      <div className="mt-5 flex gap-3 overflow-hidden">
        <Bar className="shrink-0 w-[238px] h-[162px] rounded-xl" />
        <Bar className="shrink-0 w-[146px] h-[162px] rounded-xl" />
      </div>

      <div className="mt-6">
        <Bar className="h-4 w-20" />
        <div className="mt-3.5 flex gap-3.5 overflow-hidden">
          {Array.from({ length: 6 }).map((_, i) => (
            <div key={i} className="flex flex-col items-center shrink-0">
              <Bar className="w-11 h-11 rounded-full" />
              <Bar className="mt-1.5 h-2.5 w-12" />
            </div>
          ))}
        </div>
      </div>

      <div className="mt-6">
        <Bar className="h-4 w-24" />
        <div className="mt-3 rounded-xl bg-white border border-black/[0.05] divide-y divide-black/[0.05]">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="flex items-center gap-3 px-4 py-3">
              <Bar className="w-9 h-9 shrink-0 rounded-full" />
              <div className="flex-1">
                <Bar className="h-3.5 w-1/2" />
                <Bar className="mt-2 h-2.5 w-2/5" />
              </div>
              <Bar className="h-3.5 w-14 shrink-0" />
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
);

export default WalletScreenSkeleton;
